import { render, staticRenderFns } from "./MinigamesTabsFilter.vue?vue&type=template&id=2fb4c1bc&scoped=true"
import script from "./MinigamesTabsFilter.vue?vue&type=script&lang=js"
export * from "./MinigamesTabsFilter.vue?vue&type=script&lang=js"
import style0 from "./MinigamesTabsFilter.vue?vue&type=style&index=0&id=2fb4c1bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb4c1bc",
  null
  
)

export default component.exports